"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["html,body{background-color:#f2f2f2;margin:0 auto !important;padding:0 !important;width:100% !important;height:100% !important;}a:visited{color:inherit;}@media only screen and (max-device-width:480px){.container td{padding:0 5px!important;}.container--without-padding td{padding:0!important;}}.desktop-only-block{display:block !important;}.mobile-only-block{display:none !important;}td.desktop-only-block{display:table-cell !important;}td.mobile-only-block{display:none !important;}@media only screen and (max-width:480px){.desktop-only-block{display:none !important;}.mobile-only-block{display:block !important;}td.desktop-only-block{display:none !important;}td.mobile-only-block{display:table-cell !important;}}"]);
var styles = {
  layout: {
    width: '100%',
    backgroundColor: _userflow["default"].colors.concrete
  },
  prehead: {
    display: 'none',
    fontSize: '1px',
    lineHeight: '1px',
    maxHeight: 0,
    maxWidth: 0,
    opacity: 0,
    overflow: 'hidden',
    msoHide: 'all',
    fontFamily: 'sans-serif'
  }
};
var Layout = function Layout(_ref) {
  var title = _ref.title,
    prehead = _ref.prehead,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GlobalStyle, null), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.prehead
  }, prehead || title), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.layout
  }, children));
};
Layout.defaultProps = {
  title: 'Level.Travel',
  prehead: ''
};
Layout.propTypes = {
  title: _propTypes["default"].string,
  prehead: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = Layout;